export default __webpack_public_path__ + "img/Montserrat-Black_fe4a1ef.eot";